import styled from 'styled-components'

export const Container = styled.div`
  padding: 16px;

  background-color: ${({ theme }) => theme.colors.primaryTint[10]};
  border-radius: ${({ theme }) => theme.radii.xxlarge};
`

export const Title = styled.p`
  padding: 0;
  margin: 0 0 8px 0;

  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
`
export const Description = styled.p`
  padding: 0;
  margin: 0 0 0px 0;

  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
`
